<router-outlet
  *ngIf="
    !iframeService.isInIframe() || (iframeService.iframeModeEnabled$ | async)
  "
></router-outlet>
